jQuery(document).ready(function(jQuery){
    //$(".single-option-selector").css("width","100%");
    $('.typeahead').typeahead();
    $('.dropdown-toggle').dropdown();
 //    $(".fancybox").fancybox({
 //        	openEffect	: 'none',
	//     	closeEffect	: 'none',
 //            nextEffect  : 'fade',
 //            prevEffect : 'fade',
 //            nextSpeed : 'slow',
 //            prevSpeed : 'slow',
 //            arrows  : true
	// });
})

